import React, { useState, useEffect } from 'react';

// モックデータ
const MOCK_DATA = {
  qiita: [
    {
      title: "Qiitaサンプル記事1",
      link: "https://qiita.com/sample1",
      date: "2024-01-01T00:00:00.000Z",
      description: "Qiitaのサンプル記事の説明"
    },
    {
      title: "Qiitaサンプル記事2",
      link: "https://qiita.com/sample12",
      date: "2024-01-02T00:00:00.000Z",
      description: "Qiitaのサンプル記事の説明"
    },
    {
      title: "Qiitaサンンプル記事3",
      link: "https://qiita.com/sample13",
      date: "2024-01-03T00:00:00.000Z",
      description: "Qiitaのサンプル記事の説明"
    },
    {
      title: "Qiitaサンプル記事4",
      link: "https://qiita.com/sample4",
      date: "2024-01-04T00:00:00.000Z",
      description: "Qiitaのサンプル記事の説明"
    },
    {
      title: "Qiitaサンプル記事5",
      link: "https://qiita.com/sample5",
      date: "2024-01-05T00:00:00.000Z",
      description: "Qiitaのサンプル記事の説明"
    },
    {
      title: "Qiitaサンプル記事6",
      link: "https://qiita.com/sample6",
      date: "2024-01-06T00:00:00.000Z",
      description: "Qiitaのサンプル記事の説明"
    },
  ],
  note: [
    {
      title: "noteサンプル記事1",
      link: "https://note.com/sample1",
      date: "2024-01-01T00:00:00.000Z",
      description: "サンプル記事の説明"
    },
    {
      title: "noteサンプル記事2",
      link: "https://note.com/sample2",
      date: "2024-01-02T00:00:00.000Z",
      description: "サンプル記事の説明"
    },
    {
      title: "noteサンプル記事3",
      link: "https://note.com/sample1",
      date: "2024-01-03T00:00:00.000Z",
      description: "サンプル記事の説明"
    },
    {
      title: "noteサンプル記事4",
      link: "https://note.com/sample2",
      date: "2024-01-04T00:00:00.000Z",
      description: "サンプル記事の説明"
    },
    {
      title: "noteサンプル記事5",
      link: "https://note.com/sample1",
      date: "2024-01-05T00:00:00.000Z",
      description: "サンプル記事の説明"
    },
    {
      title: "noteサンプル記事6",
      link: "https://note.com/sample2",
      date: "2024-01-06T00:00:00.000Z",
      description: "サンプル記事の説明"
    },
  ]
};

const BlogSection = () => {
  const [qiitaPosts, setQiitaPosts] = useState([]);
  const [notePosts, setNotePosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // 日付のソート関数
  const sortByDate = (a, b) => {
    try {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
        return 0;
      }
      return dateB.getTime() - dateA.getTime();
    } catch {
      return 0;
    }
  };


  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setIsLoading(true);

        if (process.env.NODE_ENV === 'development') {
          // noteの記事を日付順にソートして6件取得
          const sortedNotePosts = MOCK_DATA.note
            .sort(sortByDate)
            .slice(0, 6);

          // qiitaの記事を日付順にソートして6件取得
          const sortedQiitaPosts = MOCK_DATA.qiita
            .sort(sortByDate)
            .slice(0, 6);

          // 開発環境ではモックデータを使用
          setTimeout(() => {
            setQiitaPosts(sortedQiitaPosts);
            setNotePosts(sortedNotePosts);
            setIsLoading(false);
          }, 1000); // ローディング状態を確認するため1秒待機
          return;
        }

        // 本番環境では実際のAPIを呼び出し
        const API_URL = process.env.REACT_APP_API_URL;
        const [qiitaResponse, noteResponse] = await Promise.all([
          fetch(`${API_URL}/qiita-posts`),
          fetch(`${API_URL}/note-posts`)
        ]);

        if (!qiitaResponse.ok) {
          throw new Error('Qiita記事の取得に失敗しました');
        }
        if (!noteResponse.ok) {
          throw new Error('note記事の取得に失敗しました');
        }

        const qiitaData = await qiitaResponse.json();
        const noteData = await noteResponse.json();

        setQiitaPosts(qiitaData);
        setNotePosts(noteData);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching blog posts:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPosts();
  }, []);

  // スケルトンローディングコンポーネント
  const SkeletonCard = () => (
    <article className="skeleton-card bg-white rounded-lg shadow-sm p-6" aria-label="記事を読み込み中">
      <div className="h-4 bg-gray-200 rounded w-3/4 mb-4 animate-pulse"></div>
      <div className="h-3 bg-gray-200 rounded w-1/2 animate-pulse"></div>
    </article>
  );

  // テキストサニタイズ関数
  const sanitizeText = (text) => {
    if (!text) return '';
    // HTMLタグを除去し、長さを制限
    return text
      .replace(/<[^>]*>/g, '') // HTMLタグを除去
      .replace(/&[^;]+;/g, (match) => {
        // HTMLエンティティをデコード
        const entities = {
          '&amp;': '&',
          '&lt;': '<',
          '&gt;': '>',
          '&quot;': '"',
          '&#39;': "'",
          '&nbsp;': ' '
        };
        return entities[match] || ' ';
      })
      .trim()
      .substring(0, 200); // 長さを200文字に制限
  };

  // 日付フォーマット関数
  const formatDate = (dateStr) => {
    try {
      const date = new Date(dateStr);
      // 無効な日付かチェック
      if (isNaN(date.getTime())) {
        return '日付不明';
      }
      return new Intl.DateTimeFormat('ja-JP', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }).format(date);
    } catch (error) {
      console.error('Date formatting error:', error);
      return '日付不明';
    }
  };

  if (error) {
    return (
      <section className="blog-section-error py-16 bg-gray-50" role="alert" aria-labelledby="error-heading">
        <div className="max-w-4xl mx-auto px-4">
          <h2 id="error-heading" className="sr-only">エラーが発生しました</h2>
          <p className="text-red-600 text-center">{error}</p>
        </div>
      </section>
    );
  }

  return (
    <section className="blog-section py-16 bg-gray-50" aria-labelledby="blog-heading">
      <div className="max-w-4xl mx-auto px-4">
        <h2 id="blog-heading" className="sr-only">ブログ記事</h2>
        
        {/* Qiita Articles */}
        <section className="qiita-section mb-16" aria-labelledby="qiita-heading">
          <h3 id="qiita-heading" className="section-heading text-3xl font-bold mb-8 text-gray-800">
            <a href="https://qiita.com/revsystem" target="_blank" rel="noopener noreferrer" className="text-gray-800 hover:text-blue-600 transition-colors">
              Qiita
            </a>
          </h3>
          <div className="article-grid grid grid-cols-1 md:grid-cols-2 gap-6">
            {isLoading ? (
              <div className="loading-grid space-y-4" aria-live="polite" aria-label="Qiita記事を読み込み中">
                {[1, 2, 3, 4].map((i) => (
                  <SkeletonCard key={i} />
                ))}
              </div>
            ) : (
              qiitaPosts.map((post) => (
                <article key={post.link} className="blog-post bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow">
                  <a
                    href={post.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="post-link block hover:bg-gray-50 transition-colors"
                    aria-label={`Qiita記事: ${sanitizeText(post.title)}`}
                  >
                    <div className="p-6">
                      <h4 className="post-title text-lg font-semibold text-gray-800 mb-2">
                        {sanitizeText(post.title)}
                      </h4>
                      {post.description && (
                        <p className="post-description text-gray-600 mb-2 text-sm">
                          {sanitizeText(post.description)}
                        </p>
                      )}
                      <time className="post-date flex items-center text-sm text-gray-500" dateTime={post.date}>
                        <span>{formatDate(post.date)}</span>
                      </time>
                    </div>
                  </a>
                </article>
              ))
            )}
          </div>
        </section>

        {/* note Articles */}
        <section className="note-section" aria-labelledby="note-heading">
          <h3 id="note-heading" className="section-heading text-3xl font-bold mb-8 text-gray-800">
            <a href="https://note.com/revsystem" target="_blank" rel="noopener noreferrer" className="text-gray-800 hover:text-blue-600 transition-colors">
              note
            </a>
          </h3>
          <div className="article-grid grid grid-cols-1 md:grid-cols-2 gap-6">
            {isLoading ? (
              <div className="loading-grid space-y-4" aria-live="polite" aria-label="note記事を読み込み中">
                {[1, 2, 3, 4, 5, 6].map((i) => (
                  <SkeletonCard key={i} />
                ))}
              </div>
            ) : (
              notePosts.map((post) => (
                <article key={post.link} className="blog-post bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow">
                  <a
                    href={post.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="post-link block hover:bg-gray-50 transition-colors"
                    aria-label={`note記事: ${sanitizeText(post.title)}`}
                  >
                    <div className="p-6">
                      {post.thumbnail && (
                        <figure className="post-thumbnail mb-4 aspect-video overflow-hidden rounded-lg">
                          <img
                            src={post.thumbnail}
                            alt={`${sanitizeText(post.title)}のサムネイル画像`}
                            className="w-full h-full object-cover"
                            loading="lazy"
                            width="320"
                            height="180"
                          />
                        </figure>
                      )}
                      <h4 className="post-title text-lg font-semibold text-gray-800 mb-2">
                        {sanitizeText(post.title)}
                      </h4>
                      {post.description && (
                        <p className="post-description text-gray-600 mb-2 text-sm">
                          {sanitizeText(post.description)}
                        </p>
                      )}
                      <time className="post-date flex items-center text-sm text-gray-500" dateTime={post.date}>
                        <span>{formatDate(post.date)}</span>
                      </time>
                    </div>
                  </a>
                </article>
              ))
            )}
          </div>
        </section>
      </div>
    </section>
  );
};

export default BlogSection;
